<template>
  <!-- Footer Start { -->
       <div id="footer">
         <div class="foot-area">
            <ul class="foot-nav">
               <li><router-link :to="{ name:'Policy' }">이용약관</router-link></li>
               <li><router-link :to="{ name:'Privacy' }">개인정보처리방침</router-link></li>
               <li><router-link :to="{ name:'Notice' }">공지사항</router-link></li>
               <li><a href="javascript:;" @click="onLoginCheck">1:1문의</a></li>
             </ul>
             <address>
              회사명 : (주)플렉스머니 / 대표 : 이상준<br>사업자등록번호 : 558-86-02855<br>주소 : 서울특별시 강남구 테헤란로 503, 10층, 1011호<br>대표번호 : 1660-1737<br>
              E-MAIL : <a href="mailto:help@flexmoney.co.kr" class="link-secondary">help@flexmoney.co.kr</a>
             </address>
            <div class="foot-txt">
              &copy; 2023. FLEX MONEY Inc.All Rights Reserved.
           </div>
         </div>
 
       </div>
       <!-- } Footer End -->
 </template>
 
 <script>
import { useStore } from 'vuex';
import { computed, getCurrentInstance } from 'vue';
import { useRouter }from 'vue-router';
 export default {
    setup() {
      const emitter = getCurrentInstance().appContext.config.globalProperties.emitter;
      const store = useStore();
      const router = useRouter();
      const isLogin = computed(() => store.state.user.isLogin);

      const onLoginCheck = () => {
        if (isLogin.value) {
          router.push({
            name:'Qna'
          });
        } else {
          emitter.emit('EVENT_ALERT',{title:"알림", body: "로그인 후 이용 가능합니다."});
        }
      }
    return{
      isLogin,
      onLoginCheck
    }
  }
 }
 </script>
 
 <style>
 
 </style>